module.exports = __webpack_public_path__ + "static/media/check.ad69bf14.svg";